<template>
  <TolgeeProvider>
    <!-- <div>{{ $ct('abc.def') }}</div> -->

    <form class="app__form" method="post" :action="urlSignout">
      <input type="hidden" ref="input-csrf" name="csrfToken" :value="csrfToken" />
      <input type="hidden" name="callbackUrl" value="/callback/logout" />
      <button type="submit" ref="button-signout"></button>
    </form>

    <template #fallback>
      <div style="height: 100vh" v-loading.large="true"></div>
    </template>

    <div class="app__bar-loading-progress" v-if="loadingProgress" :style="{ width: loadingProgress * 100 + '%' }"></div>

    <loader v-if="$store.state.loader.isVisible" :bgColor="$store.state.loader.bgColor"></loader>

    <div class="app__content" v-loading.large="!$user._id">
      <router-view v-if="$route.meta.keepAlive" v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" :key="$route.path"></component>
        </keep-alive>
      </router-view>

      <router-view :key="$route.name" v-else></router-view>
    </div>

    <Toaster />
  </TolgeeProvider>
</template>

<script>
import axios from 'axios';
import tolgee from '@/tolgee.js';
import Loader from '@/components/loader.vue';
import BarHorizontal from '@/components/charts/bar-horizontal.vue';
import { defineAsyncComponent } from 'vue';
import { TolgeeProvider, useTolgee } from '@tolgee/vue';
import 'vue-sonner/style.css';
import { Toaster } from '@/components/ui/sonner';
export default {
  name: 'App',
  components: {
    Loader,
    BarHorizontal,
    TolgeeProvider,
    Toaster
  },
  async beforeCreate() {
    this.$store.commit('showLoader', { bgColor: '#0004' });
    window.addEventListener('orientationchange', function () {
      const originalBodyStyle = getComputedStyle(document.body).getPropertyValue('display');
      document.body.style.display = 'none';
      setTimeout(() => {
        document.body.style.display = originalBodyStyle;
      }, 10);
    });
    window.addEventListener('mouseover', (event) => {
      if (event.target.classList.contains('tooltip')) {
        const tooltip = event.target;
        const rect = tooltip.getBoundingClientRect();
        const xc = rect.x + rect.width / 2;
        if (xc < this.$screen.width / 2) {
          tooltip.classList.add('left');
          tooltip.classList.remove('right');
        } else {
          tooltip.classList.add('right');
          tooltip.classList.remove('left');
        }
      }
    });
  },
  created() {
    this.$store.commit('setTheme', localStorage.getItem('theme') ?? 'light');
  },
  data() {
    return {
      tolgee: useTolgee(),
      csrfToken: undefined
    };
  },
  computed: {
    ClientReloadPrompt() {
      return typeof window !== 'undefined'
        ? defineAsyncComponent((_) => import('@/components/ReloadPrompt.vue'))
        : null;
    },
    zoom() {
      return this.$store.state.zoom;
    },
    loadingProgress() {
      return this.$store.state.loadingProgress;
    },
    urlSignout() {
      return `${import.meta.env.VITE_API_URL}/auth/signout`;
    }
  },
  methods: {
    async logout() {
      const res = await this.$popupConfirm(this.$ct('navbar.logout_title'), this.$ct('navbar.logout_confirm'));
      if (!res) return;
      const {
        data: { csrfToken }
      } = await axios.get(`${import.meta.env.VITE_API_URL}/auth/csrf`);
      this.csrfToken = csrfToken;
      this.$refs['input-csrf'].value = csrfToken;
      this.$refs['button-signout'].click();
      window.faro?.api?.resetUser();
      localStorage.clear();
    }
  },
  watch: {
    '$course.color'(val) {
      if (val) {
        const color = this.getContrastTextColor(val);
        document.documentElement.style.setProperty('--color-contrast', color);
        document.documentElement.style.setProperty('--color-course', this.$course.color);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
body,
html {
  overflow-x: clip;
}
.app {
  &__bar-loading-progress {
    z-index: 100;
    position: fixed;
    top: 0;
    height: 4px;
    background-color: $cmain;
    transition: 200ms;
  }
  &__content {
    position: relative;
    font-family: 'Inter';
    transition: font-size 0.3s ease;
    @media (min-width: 960px) {
      font-size: calc(16px * v-bind(zoom));
    }
    @media (min-width: 640px) and (max-width: 960px) {
      font-size: calc(15px * v-bind(zoom));
    }
    @media (max-width: 640px) {
      font-size: calc(14px * v-bind(zoom));
    }
  }
  &__form {
    position: fixed;
    visibility: hidden;
  }
}
</style>
